import { getUrl } from '../../../../../services/ApiService'
import axiosRequest from '../../../../../utils/utils/apiRequest'
import buildParams from '../../../../../utils/utils/buildParams'
import { RequestType } from '../../../../../views/SingleRequestPage/types/Request.type'
import {
  BaseResponseType,
  CategoriesResponse,
  RequestsParams,
} from '../types/types'

const REQUESTS = {
  CLARIFICATIONS: '/operators/paged?',
  REQUESTS: '/orders/getpaged?',
  REQUESTS_ARCHIVE: '/archive/installs/orders/paged?',
  CHECK_EQUIPMENT_TABLE: '/customers/orders/sat-recovery-campaign/paged?',
}

const COMMON_DATA = {
  CATEGORIES: '/categories',
  PAYMENT_TYPES: '/FinancialSources',
}

export const UTILS_KEYS = {
  GET_CATEGORIES: 'get-categories',
  GET_PAYMENT_TYPES: 'get-payment-types',
}

export const getCategories = (): Promise<CategoriesResponse> => {
  return axiosRequest({
    url: getUrl(COMMON_DATA.CATEGORIES),
    method: 'GET',
  })
}

export function getRequests(
  params: RequestsParams,
): Promise<BaseResponseType<RequestType>> {
  const queryStingParams = buildParams(params)
  const url = `${REQUESTS.REQUESTS}${queryStingParams}`

  return axiosRequest({
    url: getUrl(url),
    method: 'GET',
  })
}

export function getRequestsArchive(
  params: RequestsParams,
): Promise<BaseResponseType<RequestType>> {
  const queryStingParams = buildParams(params)
  const url = `${REQUESTS.REQUESTS_ARCHIVE}${queryStingParams}`

  return axiosRequest({
    url: getUrl(url),
    method: 'GET',
  })
}

export function getCheckEquipmentTable(
  params: RequestsParams & { fullAddress?: string; id?: string },
): Promise<BaseResponseType<RequestType>> {
  const queryStingParams = buildParams(params)
  const url = `${REQUESTS.CHECK_EQUIPMENT_TABLE}${queryStingParams}`

  return axiosRequest({
    url: getUrl(url),
    method: 'GET',
  })
}
